module.exports = __webpack_public_path__ + "img/product_41.fec59b7.webp";